import { gql } from "@apollo/client";

export const CURRENT_SUBSCRIPTION_QUERY = gql`
  query CurrentSubscription {
    currentSubscription {
      id
      status
      planCode
      stripePriceId
      currentPeriodStart
      currentPeriodEnd
      trialEndsAt
      cancelAtPeriodEnd
      usage {
        aiGenerationsUsed
        outfitsUsed
        closetItemsUsed
        lastResetAt
      }
      limits {
        aiGenerationsPerMonth
        outfitsMax
        closetItemsMax
      }
    }
  }
`;

export const CREATE_CHECKOUT_SESSION_MUTATION = gql`
  mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
    createCheckoutSession(input: $input) {
      success
      url
      errors {
        fullMessages
      }
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION_MUTATION = gql`
  mutation CreateBillingPortalSession($input: CreatePortalSessionInput!) {
    createBillingPortalSession(input: $input) {
      success
      url
      errors {
        fullMessages
      }
    }
  }
`;
